export default "__VITE_ASSET__3a8a7efc__"